import api from '@/api/manage-learners-report-downloads';

const namespaced = true;

const getters = {
  visibleColumns: state => {
    return state.columns.filter(x => x.showColumn);
  },
};

export const actions = {
  FETCH_DOWNLOADS: ({ dispatch, commit, state }) => {
    return new Promise(resolve => {
      dispatch('wait/start', 'fetching report downloads', { root: true });

      api
        .fetchDownloads({
          pageSize: state.pageSize,
          currentPage: state.currentPage,
          ordering: state.ordering,
        })
        .then(response => {
          dispatch('wait/end', 'fetching report downloads', { root: true });
          commit('SET_DOWNLOADS', { downloads: response.results });
          commit('SET_DOWNLOADS_COUNT', { count: response.count });
          resolve(response);
        });
    });
  },
};

export const mutations = {
  SET_PAGE_SIZE(state, { pageSize }) {
    state.pageSize = pageSize;
    state.currentPage = 0;
  },
  SET_CURRENT_PAGE(state, { currentPage }) {
    state.currentPage = currentPage;
  },
  SET_ORDERING(state, { ordering }) {
    state.ordering = ordering;
    state.currentPage = 0;
  },
  SET_DOWNLOADS_COUNT(state, { count }) {
    state.count = count;
  },
  SET_DOWNLOADS(state, { downloads }) {
    state.downloads = downloads;
  },
};

const state = {
  downloads: [],
  count: 0,
  columns: [
    {
      id: 1,
      label: 'Time requested',
      field_name: 'created',
      source_field: 'created',
      showColumn: true,
      type: 'datetime',
    },
    {
      id: 2,
      label: 'Organization',
      field_name: 'organization',
      source_field: 'organization',
      showColumn: true,
    },
    {
      id: 3,
      label: 'Start Date',
      field_name: 'start_date',
      source_field: 'start_date',
      showColumn: true,
      type: 'date',
    },
    {
      id: 4,
      label: 'End Date',
      field_name: 'end_date',
      source_field: 'end_date',
      showColumn: true,
      type: 'date',
    },
    {
      id: 5,
      label: 'Download',
      field_name: 'url',
      source_field: 'url',
      showColumn: true,
    },
  ],
  pageSize: 15,
  currentPage: 0,
  ordering: null,
};

export default {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};
